<template>
    <div>
        <vs-row class="pt-3 pb-3">
            <vs-col v-if="infoCard && infoCard.total_alumnos && infoCard.total_alumnos !== ''" sm="12" lg="3" class="mt-2 ml-2 mr-2">
                <md-card class="text-center md-primary" md-with-hover>
                    <md-ripple>
                        <md-card-header class="d-flex mb-0">
                            <div class="md-subhead">Alumnos totales</div>
                            <div class="md-title"> {{infoCard.total_alumnos}}</div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
            <vs-col v-if="infoCard && infoCard.total_monto && infoCard.total_monto !== ''" sm="12" lg="3" class="mt-2 ml-2 mr-2">
                <md-card class="text-center md-succes" md-with-hover>
                    <md-ripple>
                        <md-card-header class="d-flex mb-0">
                            <div class="md-subhead">Monto total</div>
                            <div class="md-title">{{infoCard.total_monto | currency}}</div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
            <vs-col v-if="infoCard && infoCard.total_transacciones && infoCard.total_transacciones !== ''" sm="12" lg="3" class="mt-2 ml-2 mr-2">
                <md-card class="text-center md-info" md-with-hover>
                    <md-ripple>
                        <md-card-header class="d-flex mb-0">
                            <div class="md-subhead">Transacciones totales</div>
                            <div class="md-title">{{infoCard.total_transacciones}}</div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
export default {
    props:[
        'infoCard'
    ],
    data(){
        return{
            active: 0,
            isActive: false,
            colores: [
                {
                    color: 'md-primary'
                },
                {
                    color: 'md-success'
                },
                {
                    color: 'md-info'
                },
                {
                    color: 'md-dark'
                }
            ]
        }
    },
    methods: {
        showCard() {
            this.isActive = !this.isActive
        }
    }
    
}
</script>

<style lang="scss"  scoped >
.separated {
    margin: 0.7em  !important;   
}
.md-list {
     padding: 0.7rem;
}

.md-divider {
    height: 1px;
    color: #4b647a98 !important;
}

.md-card .md-card-header .vs-avatar-content{
    height: 100% !important; 
}

.md-card-header-text {
    margin-left: 1em;
}

.md-progress-bar {
    margin: 24px;
}

.table-search-button {
    margin: 0px auto 0px auto;
    @media only screen and (max-width: 768px) {
        margin: 0 0 0 auto;
  }
}

.vs-select-content {
    padding: 0 !important;
    width: 100%;
    max-width: 100%;
    @media only screen and (max-width: 768px) {
        margin-bottom: 5%;
  }
}

.card-content{
    @media only screen and (max-width: 768px) {
        text-align: center;
    }
}
.fontMedium{
    font-size: 13px;
}

.hoverList :hover{
    background: rgba(165,165,165,0.1);
    cursor: pointer;
}

.md-succes{
    background: #28a745;
    color: white;
    border-radius: 7px;
}

.md-primary{
    border-radius: 7px;
}

.md-subhead{
    width: 36%;
    display: flex;
    align-items: center;
}

.md-title{
    width: 64%;
    margin-top: 0 !important;
    text-align: right;
}

.md-info{
    background: #9e16aa;
    color: white;
    border-radius: 7px;
}

.md-dark{
    background: #19191a;
    color: white;
    border-radius: 7px;
}
</style>
